/* eslint no-undef:0 no-use-before-define:0 */
import _isString from 'lodash/isString';
import { pageNames } from './page-name-identifiers';
import { getFPTIPageId, getCountry, getLocale, getFPTILogin, URLReplacement, validateFpti } from './page';
import poll from './poll';

const maskRegEx = /(\d\d+|(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,}))/g; // eslint-disable-line
const maskPattern = '#########';

// FPTI object checker
const trackingHelper = (callback, options) => (
  poll(validateFpti, 4, 500)
    .then(() => callback(options))
    .catch(() => {}));

// Send FPTI click event with waiting for FPTI option available
const trackLink = params => trackingHelper((options) => {
  const fpti = pageFPTIFormate(options);

  if (getFPTIPageId() !== 'articlePage') {
    fpti.hpid = '';
  }

  if (options.feedback) {
    fpti.hcar = options.feedback.hcar;
    fpti.hcaf = options.feedback.hcaf;
  } else {
    // Clear hcar and hcaf
    fpti.hcar = '';
    fpti.hcaf = '';
  }

  // clearing out error props in case they exist
  fpti.erpg = '';
  fpti.erfd = '';
  fpti.eccd = '';

  // setting component
  fpti.comp = 'smarthelpnodeweb';
  fpti.rsta = fpti.rsta || getRSTA();
  try {
    PAYPAL.analytics.Analytics.prototype.recordClick({ data: fpti });
  } catch (e) {
    // suppress error
  }
}, params);

// Send FPTI impression event with waiting for FPTI option available
const trackPage = params => trackingHelper((options) => {
  fpti = Object.assign(fpti, pageFPTIFormate(options));

  // clearing out error props in case they exist
  fpti.erpg = undefined;
  fpti.erfd = undefined;
  fpti.eccd = undefined;

  // setting component
  fpti.comp = 'smarthelpnodeweb';
  fpti.rsta = fpti.rsta || getRSTA();

  try {
    PAYPAL.analytics.Analytics.prototype.recordImpression({ data: fpti });
  } catch (e) {
    // suppress error
  }
}, params);

const trackError = params => trackingHelper((options) => {
  // const fpti = {};
  // set page name
  const pageDetails = getPageDetails(options.id);
  fpti.pgrp = pageDetails.pageGroupName;
  fpti.page = pageDetails.pageName;

  if (options.errorField) {
    fpti.erpg = pageDetails.pageName;
    fpti.erfd = options.errorField;
  }

  PAYPAL.analytics.Analytics.prototype.recordImpression({ data: fpti });
}, params);

const trackSetUp = params => trackingHelper((options) => {
  if (typeof window.fptiData === 'undefined') {
    window.fptiData = '';
  }

  if (typeof window.fptiUrl === 'undefined') {
    window.fptiUrl = '';
  }

  let fptiTmp = fptiData || '';
  const customerOptions = pageFPTIFormate(options);

  Object.keys(customerOptions)
    .forEach((key) => {
      fptiTmp = URLReplacement(fptiTmp, key, customerOptions[key]);
    });

  PAYPAL.core = PAYPAL.core || {};
  PAYPAL.core.pta = PAYPAL.analytics.setup({ data: fptiTmp, url: fptiUrl, trackFormAbandonment: false });
  PAYPAL.analytics.startClientErrorTracking();
}, params);

function getPageDetails(id) {
  return pageNames[id];
}

function dataMasking(data) {
  if (_isString(data)) {
    return data.replace(maskRegEx, maskPattern);
  }

  return data;
}

// Country and locale info in the FPTI
function getRSTA() {
  return `${getCountry()
    .toUpperCase()}|${getLocale()
    .replace('-', '_')}`;
}

function pageFPTIFormate(options) {
  const fptiKeys = {};
  fptiKeys.link = options.link; // set link name

  const pageDetails = getPageDetails(options.id); // set page name
  fptiKeys.pgrp = pageDetails.pageGroupName;
  fptiKeys.page = pageDetails.pageName;
  fptiKeys.lgin = getFPTILogin();

  if (options.link) {
    fptiKeys.pglk = `${pageDetails.pageGroupName}|${options.link}`;
    fptiKeys.pgln = `${pageDetails.pageName}|${options.link}`;
  } else {
    fptiKeys.pglk = '';
    fptiKeys.pgln = '';
  }

  if (options.hpid) {
    fptiKeys.hpid = options.hpid;
  }

  if (options.srch) {
    fptiKeys.srch = dataMasking(options.srch);
  } else {
    fptiKeys.srch = '';
  }

  return fptiKeys;
}

module.exports = { trackError, dataMasking, trackLink, trackPage, trackSetUp };
